import React from 'react';
import Seo from '../../components/utils/Seo';
import HeroTopHome from '../../components/marketing/heroTop/HeroTopHome';
import BodyHomePage from './body/BodyHomePage'
import Footer from '../../components/marketing/footer/Footer';

function Home(props) {
    return (
        <div className="selection:bg-primary selection:text-white">
            <Seo
                title="Traductrice des langues - rita nsangou"
                description="Rita nsangou est la solution pour tout vos problèmes de traduction. français-anglais-espagnol"
            />
            <HeroTopHome />
            <BodyHomePage />
            <Footer />
        </div>
    );
}

export default Home;